import OrthodonticOrderDetails from "./OrthodonticOrderDetails";
import { OrthodonticCaseDetailsSectionV2 } from "../../Components/Order-Comps/OrthodonticCaseDetailsSectionV2";

function OrthodonticOrderDetailsV2(props) {
  return <OrthodonticOrderDetails {...props} CaseDetailsComponent={OrthodonticCaseDetailsSectionV2} />;
}

export default OrthodonticOrderDetailsV2;
